import React, { useEffect, useState } from 'react';
import { Popover, Box, Stack, TextField, Button, Select, MenuItem, Typography } from '@mui/material';

const ROLES = [
  'Manager',
  'Assistant Manager',
  'Team Lead',
  'Cashier',
  'Sales Associate',
  'Front Desk',
  'Inventory'
];

export default function InlineShiftEditor({ open, anchorEl, shift, onClose, onSave, onDelete, onOpen }) {
  const [role, setRole] = useState('');
  const [start, setStart] = useState('09:00');
  const [end, setEnd] = useState('17:00');
  const [saving, setSaving] = useState(false);
  const pad2 = (n) => String(n).padStart(2, '0');
  const formatLocalDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;
  const formatLocalDateTime = (d) => `${formatLocalDate(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;

  useEffect(() => {
    if (!shift) return;
    const s = new Date(String(shift.start_ts).replace(' ', 'T'));
    const e = new Date(String(shift.end_ts).replace(' ', 'T'));
    setRole(shift.role || '');
    setStart(s.toTimeString().slice(0,5));
    setEnd(e.toTimeString().slice(0,5));
  }, [shift]);

  const handleSave = async () => {
    if (!shift) return;
    setSaving(true);
    try {
      const base = new Date(String(shift.start_ts).replace(' ', 'T'));
      const dateStr = formatLocalDate(base);
      const startDateTime = new Date(`${dateStr}T${start}:00`);
      const endDateTime = new Date(`${dateStr}T${end}:00`);
      if (endDateTime <= startDateTime) endDateTime.setDate(endDateTime.getDate() + 1);

      await onSave({
        role: role || shift.role,
        start_ts: formatLocalDateTime(startDateTime),
        end_ts: formatLocalDateTime(endDateTime),
        break_minutes: shift.break_minutes || 0,
        employee_id: shift.employee_id,
        notes: shift.notes || null
      }, shift.id);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ p: 1.5, minWidth: 280 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>Quick Edit</Typography>
          <Stack direction="row" spacing={1}>
            {onOpen && <Button size="small" onClick={()=>{ onOpen(); }}>Open</Button>}
            {onDelete && <Button size="small" color="error" onClick={async()=>{ if (shift?.id){ await onDelete(shift.id); onClose(); } }}>Delete</Button>}
          </Stack>
        </Stack>
        <Stack spacing={1.25}>
          <Select size="small" value={role} onChange={(e) => setRole(e.target.value)} displayEmpty>
            <MenuItem value=""><em>Role</em></MenuItem>
            {ROLES.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
          </Select>
          <Stack direction="row" spacing={1}>
            <TextField size="small" type="time" label="Start" value={start} onChange={(e)=>setStart(e.target.value)} fullWidth />
            <TextField size="small" type="time" label="End" value={end} onChange={(e)=>setEnd(e.target.value)} fullWidth />
          </Stack>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button size="small" onClick={onClose}>Cancel</Button>
            <Button size="small" variant="contained" onClick={handleSave} disabled={saving}>Save</Button>
          </Stack>
        </Stack>
      </Box>
    </Popover>
  );
}
